import React, { useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { DialogContent, DialogTitle } from 'Views/Page/Content/Modal/Components';
import {
  FDStack,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import fr from 'facet-rest';
import AssetAndLiabilityDialogActions
  from 'Views/Page/Content/Templates/DigitalOnboardingRealAssetInfo/AssetAndLiabilityDialogActions';
import PropTypes from 'prop-types';

const DigitalOnboardingRealAssetInfoTemplate = ({ isPartOfTypeStep }) => {
  const {
    onSubmit, resource, saving, consumeAttr,
  } = useMetaLayoutContext();
  const { refreshOnboardingStepCollection } = useSurveyContext();
  const [loading, setLoading] = useState(false);
  const { displayErrorMessage } = useSnackbarContext();
  const { loadModalCollectionByLink, clearModalCollection } = useModalContext();

  const handleSaveAndClose = async () => {
    try {
      setLoading(true);
      const resp = await onSubmit();
      if (resp) {
        await refreshOnboardingStepCollection();
        clearModalCollection();
      }
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Error saving');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveAndAddAnother = async (rel) => {
    try {
      setLoading(true);
      await resource.submit();
      await loadModalCollectionByLink(rel.link('related').url());
      refreshOnboardingStepCollection(); // Not awaiting because the user should be able to interact with the new form before we finish refreshing - we can do this refresh in the background
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Error saving');
    } finally {
      setLoading(false);
    }
  };

  const isEdit = resource.id() > 0;
  const defaultTitle = isEdit ? 'Edit asset' : 'Add an asset';

  return (
    <>
      {!isPartOfTypeStep ? <DialogTitle value={consumeAttr('title') ?? defaultTitle} /> : null}
      <DialogContent>
        <FDStack
          spacing={2}
          direction={'column'}
          alignItems={'stretch'}
          {...dataAttrs('digital-onboarding-real-asset-info-template')}
        >
          <MetaControlField attr={'name'} simpleRootStyle />
          <MetaControlField attr={'type'} />
          <MetaControlField attr={'subType'} />
          <MetaControlField attr={'value'} simpleRootStyle />
          <MetaControlField attr={'ownerClientId'} />
          <MetaControlField attr={'owner'} />
          <MetaLayoutRemainingFields noAccordion />
        </FDStack>
      </DialogContent>
      { !isPartOfTypeStep ? <AssetAndLiabilityDialogActions
        addAnotherRel={resource.relationship(fr.relationships.addRealAsset.name)}
        handleSaveAndAddAnother={handleSaveAndAddAnother}
        handleSaveAndClose={handleSaveAndClose}
        isLoading={loading || saving}
        isDisabled={false}
        useFD={false}
      /> : null}
    </>
  );
};

DigitalOnboardingRealAssetInfoTemplate.defaultProps = {
  isPartOfTypeStep: false,
};

DigitalOnboardingRealAssetInfoTemplate.propTypes = {
  isPartOfTypeStep: PropTypes.bool,
};

export default DigitalOnboardingRealAssetInfoTemplate;
